import { useCallback } from "react";

import { useRouter } from "next/router";
import { trackAmplitudeEvent } from "../../utils/amplitude";
import { customerAnalytics } from "../../utils/APICalls/APICalls";
import { getCookie } from "../../utils/CookieHelper";
import { COOKIE_ENUM, CUSTOMER_ANALYTICS_EVENT } from "../../utils/enums";
import envConfig from "../../utils/env.config";
import { getFranchiseSlug } from "../../utils/help/navigation/navigation";
import { AnalyticsExtraInfo } from "../../utils/types";

export const useCustomerAnalytics = () => {
  const router = useRouter();

  const { franchise } = router.query;

  const addCustomerAnalytics = useCallback(
    (
      event: CUSTOMER_ANALYTICS_EVENT,
      extraInfo?: AnalyticsExtraInfo,
      franchiseId?: number,
      franchiseSlug?: string
    ) => {
      const token = getCookie(COOKIE_ENUM.TOKEN);

      const effectiveFranchiseSlug =
        franchiseSlug || getFranchiseSlug(franchise as string);

      try {
        trackAmplitudeEvent(event as string, {
          ...extraInfo,
          franchise: effectiveFranchiseSlug,
          restaurantId: envConfig.restaurantId,
          timestamp: new Date().toISOString(),
        });
      } catch (error) {
        console.debug("Failed to track event with Amplitude:", error);
      }

      if (token && router.isReady) {
        customerAnalytics(
          event,
          extraInfo,
          franchiseId,
          parseInt(envConfig.restaurantId!),
          effectiveFranchiseSlug
        ).catch((e) =>
          console.debug(
            e,
            "Couldn't add the customer analysis " + event + " to db"
          )
        );
      } else {
        console.log(
          "Was not able to add customer analytics, because TOKEN is not in cookies"
        );
      }
    },
    []
  );

  return addCustomerAnalytics;
};
